<div class="mds-layout">
  <mc-top-bar product="MGF SSO Admin" productshort="SSO Admin">
  </mc-top-bar>
  <router-outlet />
</div>
